"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var MenuPopButton_1 = __importDefault(require("../Menu/MenuPopButton"));
var useFullscreen_1 = __importDefault(require("./useFullscreen"));
function FullscreenPopButton() {
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, react_2.useState)(true), pop = _a[0], setPop = _a[1];
    (0, react_2.useEffect)(function () {
        setTimeout(function () { return setPop(false); }, 5000);
    }, []);
    var _b = (0, useFullscreen_1.default)(), fullscreen = _b.fullscreen, toggleFullscreen = _b.toggleFullscreen;
    return ((0, jsx_runtime_1.jsx)(MenuPopButton_1.default, __assign({ pop: pop, onClick: toggleFullscreen, css: style, title: fullscreen ? t('Leave full screen') : t('Go to full screen') }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: fullscreen ? free_solid_svg_icons_1.faCompress : free_solid_svg_icons_1.faExpand }) })));
}
exports.default = FullscreenPopButton;
var style = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: white;\n  color: #28b8ce;\n  &:focus, &:hover {\n    background: #f0fbfc;\n  }\n  &:active {\n    background: #dbf5f8;\n  }\n"], ["\n  background: white;\n  color: #28b8ce;\n  &:focus, &:hover {\n    background: #f0fbfc;\n  }\n  &:active {\n    background: #dbf5f8;\n  }\n"])));
var templateObject_1;
